<template>
  <div class="text-ellipsis" style="">{{value}}</div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
};
</script>
<style>
.text-ellipsis {
  margin-right:4px;line-height: 16px;
    background-color: #fff;
   border-radius:4px;
    color: #409eff;
  padding: 4px;
  width: 65px; /* 容器宽度 */
  white-space: nowrap; /* 文本不换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
  border: 1px solid #b3d8ff; /* 仅为了方便观察效果 */
}
</style>
